// Effet Typewriter - Position fixe pour le texte de la page blog
document.addEventListener('DOMContentLoaded', function() {
  const textBlock = document.querySelector('.text-block--AV282RmF0dWRuc0RLV__text_pcwxfg');
  
  if (!textBlock) return;
  
  const paragraphs = textBlock.querySelectorAll('p');
  
  // Sauvegarder le texte original
  const originalTexts = [];
  paragraphs.forEach(function(p) {
    originalTexts.push(p.textContent);
  });
  
  // Mesurer les dimensions avec le texte complet
  const originalWidth = textBlock.offsetWidth;
  const originalHeight = textBlock.offsetHeight;
  const maxWidth = textBlock.offsetWidth;
  
  // Fixer les dimensions du conteneur
  textBlock.style.width = originalWidth + 'px';
  textBlock.style.minHeight = originalHeight + 'px';
  
  // Préparer chaque paragraphe
  paragraphs.forEach(function(p, index) {
    const fullText = originalTexts[index];
    const fullHeight = p.offsetHeight;
    
    p.style.opacity = '1';
    p.style.visibility = 'visible';
    p.style.textAlign = 'center';
    p.style.minHeight = fullHeight + 'px';
    
    // Créer un span avec texte centré
    p.innerHTML = '<span style="display: inline-block; max-width: ' + maxWidth + 'px; text-align: center; white-space: pre-wrap; word-wrap: break-word;"></span>';
  });
  
  let currentParagraph = 0;
  
  function typeWriter(element, text, speed, callback) {
    const span = element.querySelector('span');
    let i = 0;
    
    function type() {
      if (i < text.length) {
        span.textContent += text.charAt(i);
        i++;
        setTimeout(type, speed);
      } else {
        if (callback) {
          setTimeout(callback, 300);
        }
      }
    }
    
    type();
  }
  
  function typeNextParagraph() {
    if (currentParagraph < paragraphs.length) {
      const p = paragraphs[currentParagraph];
      const text = originalTexts[currentParagraph];
      
      typeWriter(p, text, 15, function() {
        currentParagraph++;
        typeNextParagraph();
      });
    }
  }
  
  typeNextParagraph();
});

// Effet Typewriter - Aligné à droite, fixe (pour la bulle néon)
document.addEventListener('DOMContentLoaded', function() {
  const textBlock = document.querySelector('.text-block--ATWl4ZklxeXBYM0Zjb__text_zRaVdr');
  const textElement = textBlock?.querySelector('p');
  
  if (!textElement) return;
  
  const originalText = textElement.textContent.trim();
  
  // Mesurer et fixer les dimensions
  const originalWidth = textBlock.offsetWidth;
  const originalHeight = textBlock.offsetHeight;
  
  textBlock.style.width = originalWidth + 'px';
  textBlock.style.height = originalHeight + 'px';
  textBlock.style.minWidth = originalWidth + 'px';
  textBlock.style.minHeight = originalHeight + 'px';
  
  // Créer un conteneur avec largeur fixe
  textElement.innerHTML = `<span style="display: inline-block; text-align: left; min-width: ${textElement.offsetWidth}px;"></span>`;
  const typewriterSpan = textElement.querySelector('span');
  
  let i = 0;
  function typeWriter() {
    if (i < originalText.length) {
      typewriterSpan.textContent += originalText.charAt(i);
      i++;
      setTimeout(typeWriter, 50);
    }
  }
  
  setTimeout(typeWriter, 500);
});

// Effet Typewriter - Bloc story spécifique uniquement
document.addEventListener('DOMContentLoaded', function() {
  const textBlock = document.querySelector('.text-block--AelIrZWxCVFFESUNqb__text_pcwxfg');
  
  if (!textBlock) {
    console.log('Bloc story non trouvé');
    return;
  }
  
  console.log('Bloc story trouvé, démarrage typewriter');
  
  const paragraphs = textBlock.querySelectorAll('p');
  
  if (paragraphs.length === 0) return;
  
  // Sauvegarder le texte original
  const originalTexts = [];
  paragraphs.forEach(function(p) {
    originalTexts.push(p.textContent);
  });
  
  // Mesurer les dimensions avec le texte complet
  const originalWidth = textBlock.offsetWidth;
  const originalHeight = textBlock.offsetHeight;
  const maxWidth = textBlock.offsetWidth;
  
  // Fixer les dimensions du conteneur
  textBlock.style.width = originalWidth + 'px';
  textBlock.style.minHeight = originalHeight + 'px';
  
  // Préparer chaque paragraphe
  paragraphs.forEach(function(p, index) {
    const fullText = originalTexts[index];
    const fullHeight = p.offsetHeight;
    
    p.style.opacity = '1';
    p.style.visibility = 'visible';
    p.style.textAlign = 'center';
    p.style.minHeight = fullHeight + 'px';
    
    p.innerHTML = '<span style="display: inline-block; max-width: ' + maxWidth + 'px; text-align: center; white-space: pre-wrap; word-wrap: break-word;"></span>';
  });
  
  let currentParagraph = 0;
  
  function typeWriter(element, text, speed, callback) {
    const span = element.querySelector('span');
    let i = 0;
    
    function type() {
      if (i < text.length) {
        span.textContent += text.charAt(i);
        i++;
        setTimeout(type, speed);
      } else {
        if (callback) {
          setTimeout(callback, 300);
        }
      }
    }
    
    type();
  }
  
  function typeNextParagraph() {
    if (currentParagraph < paragraphs.length) {
      const p = paragraphs[currentParagraph];
      const text = originalTexts[currentParagraph];
      
      typeWriter(p, text, 15, function() {
        currentParagraph++;
        typeNextParagraph();
      });
    }
  }
  
  typeNextParagraph();
});


